var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-item is-inline-block-mobile",on:{"click":function($event){return _vm.toggleSetting()}}},[_c('span',[_c('i',{class:['fas', 'fa-fw', _vm.value ? _vm.icon : _vm.secondaryIcon]})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }